import { SearchService } from './SearchService';

const activeClass = 'venue_filter_bar-taxonomy_item-button--active';

export class FacetTabs<TFacets extends string, ISearchResult> {
	protected _facetName;
	protected _searchService;
	protected _element: JQuery<HTMLElement>;
	protected _tabsElement: JQuery<HTMLElement> | null;
	protected _activeClass: string = 'tab--active';

	public constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		facetName: TFacets,
		activeClass?: string,
	) {
		this._element = element;
		this._facetName = facetName;
		this._searchService = searchService;
		this._tabsElement = $('[data-facet-tab-target]', this._element);

		if (activeClass) {
			this._activeClass = activeClass;
		}

		this._tabsElement.on('click', (event) => {
			const tab = $(event.currentTarget);
			this.setSearchFacet(
				tab.hasClass(activeClass)
					? undefined
					: [tab.attr('data-facet-tab-target')],
			);
		});

		this.render();

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		this._tabsElement.each((_index, element) => {
			const tab = $(element);
			if (this.isActiveFilter(tab.attr('data-facet-tab-target'))) {
				$(element).addClass(this._activeClass);
			} else {
				$(element).removeClass(this._activeClass);
			}
		});
	}

	protected isActiveFilter(filterValue: string) {
		if (
			this._searchService.searchParams.facetsData &&
			this._facetName in this._searchService.searchParams.facetsData &&
			this._searchService.searchParams.facetsData[
				this._facetName
			].indexOf(filterValue) >= 0
		) {
			return true;
		}

		return false;
	}

	protected setSearchFacet(facetValue: string[] | undefined) {
		const newSearchParams = this._searchService.searchParams;
		if (!newSearchParams.facetsData) {
			newSearchParams.facetsData = {} as any;
		}

		if (facetValue) {
			newSearchParams.facetsData[this._facetName] = facetValue;
		} else {
			delete newSearchParams.facetsData[this._facetName];
		}

		this._searchService.searchParams = newSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetTabs.ts